'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { disableInspect, enableInspect } from '@src/actions/inspect.actions';
import { GladlyChat } from '@src/components/Gladly/GladlyChat';
import { configPublic } from '@src/config.public';
import { useTimezoneCookie } from '@src/hooks/useTimezoneCookie';
import { AmplitudeWebExperiment } from '@src/utils/AmplitudeWebExperiment';
import { Digioh } from '@src/utils/Digioh';
import { Ketch } from '@src/utils/Ketch';
import { Osano } from '@src/utils/Osano';
import { useAnalytics } from '@src/utils/analytics.util';
import { useDataDog } from '@src/utils/datadog.util';
import { useGeolocation } from '@src/utils/geolocation';
import { GoogleTagManager } from '@src/utils/googleTagManager.util';
import { interceptConsole } from '@src/utils/log.util';
export interface InitContext {
  vercelDeploymentUrl: string;
}
export function Init(initContext) {
  const $ = _c(2);
  interceptConsole();
  useDataDog(initContext);
  useAnalytics();
  useGeolocation();
  useTimezoneCookie();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{configPublic.ketch.isEnabled && <Ketch />}{configPublic.osano.isEnabled && <Osano />}<GoogleTagManager /><Digioh /><AmplitudeWebExperiment />{configPublic.featureFlags.faqEnabled && <GladlyChat />}</>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  globalThis.actions = {
    enableInspect,
    disableInspect
  };
}